module.exports = require("@swa-ui/core/src/HorizontalList/HorizontalList.module.scss");